var _style, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealeronLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 858.9 147.4",
    style: {
      enableBackground: "new 0 0 858.9 147.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF7319;}\n\t.st1{fill:#19325D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.5,9.4l-12.9,21.8c15.4,8,25.9,24,25.9,42.5c0,26.4-21.5,47.9-47.9,47.9c-26.4,0-47.9-21.5-47.9-47.9 c0-18.5,10.5-34.5,25.9-42.5L642.6,9.4c-22.8,12.4-38.2,36.6-38.2,64.3c0,40.3,32.8,73.2,73.2,73.2s73.2-32.8,73.2-73.2 C750.7,46,735.2,21.8,712.5,9.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,119.6h5.5c14.1,0,23.2-0.9,34.2-6.8c13.9-7.6,21.1-23.8,21.1-38.8c0-13.7-5.9-26.6-15-34.6 C61,29.6,47.3,27.7,31,27.7H26V119.6z M0,3.4h31.9c34.6,0,49.6,9.3,57.8,16.3C103,31.1,112.9,52,112.9,74.1 c0,25.3-13.1,49.6-33.6,60.8c-12.9,7.2-31,9.1-46.7,9.1H0V3.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.7,82.2c-2.8-16.9-15-24.1-28.5-24.1c-10.3,0-25.1,4.6-29.8,24.1H206.7z M149.1,102.5 c1.1,6.8,11,21.7,29.1,21.7c11.2,0,19.6-4.8,24.3-13.5h26.6c-6.1,19-26,36.7-50.9,36.7c-32.1,0-55.7-25.1-55.7-55.9 c0-29.8,22-56.6,55.5-56.6c34.6,0,54.5,28.3,54.5,54.9c0,4.9-0.8,9.3-1.5,12.7H149.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.8,58.1c-20.7,0-31.4,17.9-31.4,33.6c0,17.9,13.3,32.5,31.4,32.5c17.5,0,30.8-13.7,30.8-33.3 C329.6,69.1,313.8,58.1,298.8,58.1 M353.6,144h-23.2v-13.1c-8,9.5-23.6,16.5-36.9,16.5c-27.2,0-51.3-21.7-51.3-56.8 c0-32.3,23.6-55.7,52.8-55.7c21.5,0,34.2,15.4,35,16.9h0.4V38.5h23.2V144z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "372.3,3.4 397.6,3.4 397.6,41.1 397.6,144 372.3,144 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.1,82.2c-2.9-16.9-15-24.1-28.5-24.1c-10.3,0-25.1,4.6-29.8,24.1H498.1z M440.5,102.5 c1.1,6.8,11,21.7,29.1,21.7c11.2,0,19.6-4.8,24.3-13.5h26.6c-6.1,19-26,36.7-50.9,36.7c-32.1,0-55.7-25.1-55.7-55.9 c0-29.8,22-56.6,55.5-56.6c34.6,0,54.5,28.3,54.5,54.9c0,4.9-0.8,9.3-1.5,12.7H440.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.6,38.5h23.2v9.3h0.4c4.8-6.8,9.5-12.9,22.6-12.9h2.1v24.5c-23,1-23,19-23,25.3V144h-25.3V38.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M765.3,38.5h23.4v9.1c4.2-4,12.9-12.7,28.9-12.7c9.1,0,23,4,31.7,14.6c9.7,11.6,9.7,29.3,9.7,37.4v57h-25.3 V91.9c0-8.7,0-33.8-21.3-33.8c-4.6,0-12.7,2.3-17.3,9.3c-4.6,6.5-4.6,17.5-4.6,26.4V144h-25.3V38.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M677.5,80.2L677.5,80.2c-7,0-12.6-5.7-12.6-12.6V0h25.3v67.6C690.2,74.5,684.5,80.2,677.5,80.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealeronLogoLight);
export default __webpack_public_path__ + "static/media/dealeron-logo-light.658d5420201fa7654d65d4b59b918e11.svg";
export { ForwardRef as ReactComponent };